<template lang="pug">
	div.image-loader(v-if="imagesrc || currentStep.image")
		v-img(:src="getImage" contain)
</template>
<script>

import { mapGetters } from 'vuex';

export default {
  name: 'ImageLoader',
  computed: {
    ...mapGetters(['currentStep']),
    getImage() {
    	console.debug("imagen %s", this.imagesrc)
    	if(this.imagesrc == null){
    		return require(`@/assets/${this.currentStep.image}`);
    	}else{
    		return require(`@/assets/${this.imagesrc}`);
    	}
    }
  },
  created(){
  },
  props: {    
    imagesrc: {
      type: String,
      default: null
    }
  }  
}
</script>

<style scoped>
@import 'image-loader.scss';
</style>